/* eslint-disable prettier/prettier */
<template>
  <section class="section no-padding-mobile">
    <div class="columns is-centered">
      <div class="column is-5-desktop is-10-tablet">
        <div class="modal-card" style="z-index: 2;">
          <div class="modal-card-head">
            <b-loading
              :is-full-page="true"
              :active.sync="isLoading"
              :can-cancel="false"
            ></b-loading>
            <h1 class="title">
              {{ $t('NF3A1') }} {{ neofintechData.userData.firstName }}
              {{ neofintechData.userData.lastName }},
            </h1>
          </div>
          <div class="modal-card-body colored container">
            <div class="container">
              <ol>
                <li class="section">
                  <img src="~@/assets/icons/profilecard.svg" alt />
                  <h2 class="title is-2">1</h2>
                  <p class="is-3">{{ $t('NF3A2') }}</p>
                </li>
                <li class="section">
                  <img src="~@/assets/icons/teleoperador.svg" alt />
                  <h2 class="title is-2">2</h2>
                  <p class="is-3">{{ $t('NF3A5') }}</p>
                </li>
                <li class="section">
                  <img src="~@/assets/icons/edit.svg" alt />
                  <h2 class="title is-2">3</h2>
                  <p class="is-3">
                    {{ $t('NF3A6') }}
                  </p>
                </li>
              </ol>
            </div>
            <div class="modal-card-footer">
              <div class="container is-flex">
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
                    <b-field expanded grouped group-multiline>
                      <b-field expanded>
                        <ValidationProvider
                          :name="$t('Nombre del proyecto')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-input
                            :placeholder="`${$t('Nombre del proyecto')}*`"
                            icon="account"
                            v-model="projectName"
                            expanded
                          ></b-input>
                          <p class="help is-danger">{{ errors[0] }}</p>
                        </ValidationProvider>
                      </b-field>

                      <b-field position="is-centered">
                        <button
                          native-type="submit"
                          class="button is-full-w is-primary"
                        >
                          {{ $t('Firmar NDA') }}
                        </button>
                      </b-field>
                    </b-field>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import NotificationModal from '@/components/on-board/NotificationModal'
import Fetcher from '@/mixins/fetcher.js'
import { required, alpha_spaces } from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('alpha_spaces', {
  ...alpha_spaces
})


export default {
  mixins: [Fetcher],
  components: { ValidationProvider, ValidationObserver },
  data() {
    return {
      projectName: null
    }
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  methods: {
    ...mapActions('onBoard', ['postRequestNDASignature']),
    validateBeforeSubmit() {
      this.showNDAModal()
    },
    goToEmails: function() {
      this.$router.push({ name: 'onBoard.neofintech.phase3.emails' })
    },
    goToConference() {
      this.$router.push({ name: 'onBoard.neofintech.phase3.conference' })
    },
    showNDAModal: function() {
      let self = this
      self.$dlg.modal(NotificationModal, {
        shaking: false,
        title: false,
        params: {
          title: self.$t('Estimado solicitante'),
          bgColor: '#de4281',
          content: `
                  <div>
                  <p>${self.$t('Leer atentamente')}</p>
                  <p>1º ${self.$t('NDA_REQUEST_1')}:​</p>
                  <p>• ${self.$t('NDA_REQUEST_2')}​</p>
                  <p>• ${self.$t('NDA_REQUEST_3')}​</p>
                  <p>(*) ${self.$t('NDA_REQUEST_4')}​</p>
                  <p>2º ${self.$t('NDA_REQUEST_5')}​</p>
                  <p>3º ${self.$t('NDA_REQUEST_6')}​</p>

  
                  <p>${self.$t('The Team')}​</p></div>
                  `,
          confirmText: this.$t('Aceptar'),
          closeText: this.$t('Cerrar')
        },
        callback: () => {
          self.$router.push({ name: 'onBoard.neofintech.PreviewDraftNDA', query: { projectName: window.btoa(unescape(encodeURIComponent( self.projectName )))}})
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-content,
.modal-card {
  margin: auto;
  z-index: 99;
  border-radius: 20px;

  .modal-card-head,
  .modal-card-body {
    background: #ffffffaa;
    border: none;
  }
  .modal-card-head {
    p {
      text-align: center;
    }
    img {
      width: 300px;
    }
  }
}

.modal-card ol li {
  display: flex;

  &.section {
    border-style: solid solid none none;
    border-radius: 10px;
    border-color: var(--rosa-dark-eco);
    background-color: white;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 5px 10px -7px #00000055;
  }
  img {
    margin-right: 10px;
  }

  h2 {
    margin: auto 20px auto 0;
    color: var(--rosa-eco);
  }

  p {
    margin: auto 0;

    &.is-3 {
      color: #555;
      font-size: 17px;
      font-weight: 300;
      line-height: 1.1em;
    }
  }
}
.container.is-flex {
  flex-wrap: wrap;
}
</style>
